module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 168.6a2c796c.png";